(function($) {
    $.tfr = function(page, type, params, funcs) {
	window.params = params;
    window.funcs = funcs;
    
		if (!funcs) {
			alert("Your code has no functions");
		}
		if (!params) { 
			params = "";
			alert("Your code has no parameters.");
		} else if (!funcs.success) {
			alert("You must include a success function.");
		} else if (!funcs.error) {
			alert("You must include an error function.");
		}
				
		var type = type.toLowerCase();
		
		if (typeof funcs.start == "function") {
			funcs.start();	
		}
		
		if (type == "json") {
             $.getJSON(page + '?email=' + params.email + '&callback=?');
		}

	}
    


})(jQuery);

function tfr_process(resp) {
    p_response = resp;


	if (params.return_val) {
		p_response.return_val = params.return_val;
	}
	
	var status = p_response.status;
	if (status == "success") {
		funcs.success(p_response);
	} else if (typeof funcs[status] == "function") {
		funcs[status](p_response);
	} else {
		funcs.error(p_response);
	}
    
	if (typeof funcs.complete == "function") {
		funcs.complete();	
	}
}
            
function stripslashes(str) {
    str = str.replace(/\\'/g,'\'');
    str = str.replace(/\\"/g,'"');
    str = str.replace(/\\0/g,'\0');
    str = str.replace(/\\\\/g,'\\');
    return str;
}